export default {
	API_URL: 'https://api-cisbra.infinitum-ti.com/api',
	OAPI_URL: 'https://api-cisbra.infinitum-ti.com/oapi',
	URL: 'https://api-cisbra.infinitum-ti.com',
	// API_URL: 'http://localhost:2400/api',
	// OAPI_URL: 'http://localhost:2400/oapi',
	// URL: 'http://localhost:2400',
}
